import React, { useState } from 'react';
import { Download, FileText, Video, Link as LinkIcon, BookOpen, Briefcase, Users, Lightbulb } from 'lucide-react';
interface Resource {
  id: string;
  title: string;
  description: string;
  type: 'pdf' | 'video' | 'link' | 'embed-video';
  url: string;
  category: string;
  embedUrl?: string;
}
const resources: Resource[] = [{
  id: '1',
  title: 'Education Graduate Skills Portfolio Template',
  description: 'A customizable template to help you showcase your transferable skills to potential employers outside of traditional education.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1gfir1c7gopk8V9s6bLEe7h_mxcVMEUxt-GkMUPsZVS0/edit?usp=sharing',
  category: 'Career Transition'
}, {
  id: '2',
  title: 'Corporate Training Career Guide',
  description: 'Comprehensive overview of corporate training roles, required skills, and how to position your education background for success.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1vjgwbxujP4sVcsoPz8OxiVrWQe1HwBKjZDNIl-1XHKY/edit?usp=sharing',
  category: 'Corporate Training'
}, {
  id: '3',
  title: 'Instructional Design Portfolio Examples',
  description: 'Collection of successful portfolio examples from education graduates who transitioned to instructional design.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1ig946FDZ-AU0nV-lUPq_6ul78Q121I_8BFJ6CTOwxlQ/edit?usp=sharing',
  category: 'Instructional Design'
}, {
  id: '4',
  title: 'EdTech Industry Overview for Educators',
  description: 'Analysis of the educational technology landscape and specific roles where educators can thrive.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1cCrAfq1eQmHq8Joc5whp3F3KaQMVSnJ3CQUiL52_HMU/edit?usp=sharing',
  category: 'Educational Technology'
}, {
  id: '5',
  title: 'From Classroom to Corporate: Success Stories',
  description: 'Video interviews with education graduates who successfully transitioned to corporate careers.',
  type: 'video',
  url: 'https://www.youtube.com/watch?v=gDXwhHm4GhM',
  category: 'Career Transition'
}, {
  id: '6',
  title: 'Resume Translation Guide for Educators',
  description: 'Learn how to reframe your teaching experience and education skills for non-teaching job applications.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1y-9QxhdUPSGgIezOGkBLhZ7z8atGlzZB8UhIa6qYon0/edit?usp=sharing',
  category: 'Career Transition'
}, {
  id: '7',
  title: 'Introduction to Instructional Design Tools',
  description: 'Overview of popular tools used in instructional design with tutorials on getting started.',
  type: 'embed-video',
  url: 'https://www.youtube.com/watch?v=rpP2A8vnhI0',
  embedUrl: 'https://www.youtube.com/embed/rpP2A8vnhI0',
  category: 'Instructional Design'
}, {
  id: '8',
  title: 'Educational Consulting Business Starter Guide',
  description: 'Step-by-step guide to establishing yourself as an educational consultant using your teaching background.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1GOt44UA35kVRWNmYtwXKEJhzYflZFILPL6ePLgmW1Mw/edit?usp=sharing',
  category: 'Educational Consulting'
}, {
  id: '9',
  title: 'HR Development Career Path for Educators',
  description: 'Roadmap for transitioning from education to human resources development roles.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1cTCmZmOuZWiILfGxCdVXf-aIXnDq-Ha0jfGAfUvCl84/edit?usp=sharing',
  category: 'HR Development'
}, {
  id: '10',
  title: 'Educational NGOs in Africa Directory',
  description: 'Comprehensive list of non-profit organizations in Africa where education graduates can apply their skills.',
  type: 'link',
  url: 'https://ngobase.org',
  category: 'Non-Profit Sector'
}, {
  id: '11',
  title: 'Corporate Training Technology Tools Guide',
  description: 'An overview of the most effective technology tools used in modern corporate training environments.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1HUlD-WThzBNYfpKjvEiQSVPzMzhPvjWDvBsmlW6IiVU/edit?usp=sharing',
  category: 'Corporate Training'
}, {
  id: '12',
  title: 'How to Create Effective Learning Materials',
  description: 'Video tutorial on designing engaging learning materials for adult learners in corporate settings.',
  type: 'embed-video',
  url: 'https://www.youtube.com/watch?v=k2nGe5xXugw',
  embedUrl: 'https://www.youtube.com/embed/k2nGe5xXugw',
  category: 'Instructional Design'
}, {
  id: '13',
  title: 'Education to EdTech: Transition Guide',
  description: 'Comprehensive guide for educators looking to break into the educational technology industry.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1AzWbc5rKteEJS-1QNJzyu7R-HudaP7S2b0DxCKww7ho/edit?usp=sharing',
  category: 'Educational Technology'
}, {
  id: '14',
  title: 'Non-Profit Leadership for Educators',
  description: 'Guide to leveraging education experience for leadership roles in non-profit organizations.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1o4YX-qO9FYryEbC9uga9wbm9FpOeAMeiole3IExQQ7g/edit?usp=sharing',
  category: 'Non-Profit Sector'
}, {
  id: '15',
  title: 'Networking Strategies for Career Changers',
  description: 'Effective networking approaches specifically designed for education graduates transitioning to new fields.',
  type: 'pdf',
  url: 'https://docs.google.com/document/d/1BDHEA5VgfkevKD-Ts4eKIAa2Hd7JwSzAHe8H5QsFdQE/edit?usp=sharing',
  category: 'Career Transition'
}];
const Resources: React.FC = () => {
  const categories = Array.from(new Set(resources.map(r => r.category)));
  const [selectedCategory, setSelectedCategory] = useState<string>('All Resources');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedResource, setSelectedResource] = useState<Resource | null>(null);
  const filteredResources = resources.filter(resource => {
    const matchesCategory = selectedCategory === 'All Resources' || resource.category === selectedCategory;
    const matchesSearch = resource.title.toLowerCase().includes(searchTerm.toLowerCase()) || resource.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });
  const handleResourceClick = (resource: Resource) => {
    if (resource.type === 'link') {
      window.open(resource.url, '_blank', 'noopener,noreferrer');
    } else {
      setSelectedResource(resource);
    }
  };
  const closeModal = () => {
    setSelectedResource(null);
  };
  // Function to get the preview URL for Google Docs
  const getPreviewUrl = (url: string) => {
    return url.replace('/edit', '/preview');
  };
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1112">
        <div className="text-center mb-12" data-id="element-1113">
          <h1 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-1114">
            Career Resources
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-1115">
            Access guides, templates, and tools to help you transition from
            education studies to exciting alternative careers.
          </p>
        </div>
        {/* Featured Resource Categories */}
        <div className="mb-12 grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1116">
          <div className={`bg-white p-5 rounded-lg shadow-sm flex flex-col items-center cursor-pointer ${selectedCategory === 'Corporate Training' ? 'ring-2 ring-blue-500' : ''}`} onClick={() => setSelectedCategory('Corporate Training')} data-id="element-1117">
            <Briefcase className="h-8 w-8 text-blue-600 mb-3" data-id="element-1118" />
            <h3 className="font-medium text-gray-800 text-center" data-id="element-1119">
              Corporate Training
            </h3>
          </div>
          <div className={`bg-white p-5 rounded-lg shadow-sm flex flex-col items-center cursor-pointer ${selectedCategory === 'Instructional Design' ? 'ring-2 ring-blue-500' : ''}`} onClick={() => setSelectedCategory('Instructional Design')} data-id="element-1120">
            <Lightbulb className="h-8 w-8 text-blue-600 mb-3" data-id="element-1121" />
            <h3 className="font-medium text-gray-800 text-center" data-id="element-1122">
              Instructional Design
            </h3>
          </div>
          <div className={`bg-white p-5 rounded-lg shadow-sm flex flex-col items-center cursor-pointer ${selectedCategory === 'Educational Technology' ? 'ring-2 ring-blue-500' : ''}`} onClick={() => setSelectedCategory('Educational Technology')} data-id="element-1123">
            <BookOpen className="h-8 w-8 text-blue-600 mb-3" data-id="element-1124" />
            <h3 className="font-medium text-gray-800 text-center" data-id="element-1125">
              Educational Technology
            </h3>
          </div>
          <div className={`bg-white p-5 rounded-lg shadow-sm flex flex-col items-center cursor-pointer ${selectedCategory === 'Career Transition' ? 'ring-2 ring-blue-500' : ''}`} onClick={() => setSelectedCategory('Career Transition')} data-id="element-1126">
            <Users className="h-8 w-8 text-blue-600 mb-3" data-id="element-1127" />
            <h3 className="font-medium text-gray-800 text-center" data-id="element-1128">
              Career Transition
            </h3>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8" data-id="element-1129">
          {/* Sidebar */}
          <div className="lg:col-span-1" data-id="element-1130">
            <div className="bg-white rounded-lg shadow-sm p-6 sticky top-6" data-id="element-1131">
              <h3 className="font-medium text-gray-800 mb-4" data-id="element-1132">
                Resource Categories
              </h3>
              <nav className="space-y-1" data-id="element-1133">
                <button className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md ${selectedCategory === 'All Resources' ? 'bg-blue-100 text-blue-700' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-700'}`} onClick={() => setSelectedCategory('All Resources')} data-id="element-1134">
                  All Resources
                </button>
                {categories.map(category => <button key={category} className={`w-full flex items-center px-3 py-2 text-sm rounded-md ${selectedCategory === category ? 'bg-blue-100 text-blue-700' : 'text-gray-700 hover:bg-blue-50 hover:text-blue-700'}`} onClick={() => setSelectedCategory(category)} data-id="element-1135">
                    {category}
                  </button>)}
              </nav>
            </div>
          </div>
          {/* Main Content */}
          <div className="lg:col-span-3" data-id="element-1136">
            <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-1137">
              <div className="relative" data-id="element-1138">
                <input type="text" placeholder="Search resources..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1139" />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1140">
                  <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1141">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" data-id="element-1142" />
                  </svg>
                </div>
              </div>
            </div>
            {filteredResources.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-1143">
                {filteredResources.map(resource => <div key={resource.id} className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow cursor-pointer" onClick={() => handleResourceClick(resource)} data-id="element-1144">
                    <div className="p-6" data-id="element-1145">
                      <div className="flex items-start justify-between" data-id="element-1146">
                        <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-1147">
                          {resource.title}
                        </h3>
                        <div className="ml-4" data-id="element-1148">
                          {resource.type === 'pdf' && <div className="bg-red-100 rounded-full p-2" data-id="element-1149">
                              <FileText size={16} className="text-red-600" data-id="element-1150" />
                            </div>}
                          {(resource.type === 'video' || resource.type === 'embed-video') && <div className="bg-purple-100 rounded-full p-2" data-id="element-1151">
                              <Video size={16} className="text-purple-600" data-id="element-1152" />
                            </div>}
                          {resource.type === 'link' && <div className="bg-blue-100 rounded-full p-2" data-id="element-1153">
                              <LinkIcon size={16} className="text-blue-600" data-id="element-1154" />
                            </div>}
                        </div>
                      </div>
                      <p className="text-sm text-gray-600 mb-4 line-clamp-2" data-id="element-1155">
                        {resource.description}
                      </p>
                      <div className="flex items-center justify-between" data-id="element-1156">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-1157">
                          {resource.category}
                        </span>
                        <a href={resource.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-800" onClick={e => {
                    e.stopPropagation();
                    if (resource.type !== 'link') {
                      e.preventDefault();
                      handleResourceClick(resource);
                    }
                  }} data-id="element-1158">
                          {resource.type === 'pdf' && <>
                              <Download size={16} className="mr-1" data-id="element-1159" />
                              View Document
                            </>}
                          {(resource.type === 'video' || resource.type === 'embed-video') && <>
                              <Video size={16} className="mr-1" data-id="element-1160" />
                              Watch Video
                            </>}
                          {resource.type === 'link' && <>
                              <LinkIcon size={16} className="mr-1" data-id="element-1161" />
                              Open Link
                            </>}
                        </a>
                      </div>
                    </div>
                  </div>)}
              </div> : <div className="text-center py-12 bg-white rounded-lg shadow-sm" data-id="element-1162">
                <p className="text-lg text-gray-600" data-id="element-1163">
                  No resources found matching your search criteria.
                </p>
              </div>}
          </div>
        </div>
      </div>
      {/* Resource Viewer Modal */}
      {selectedResource && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-1164">
          <div className="bg-white rounded-lg max-w-5xl w-full max-h-[90vh] flex flex-col overflow-hidden" data-id="element-1165">
            <div className="p-4 border-b flex justify-between items-center" data-id="element-1166">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-1167">
                {selectedResource.title}
              </h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700" data-id="element-1168">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1169">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-1170"></path>
                </svg>
              </button>
            </div>
            <div className="flex-1 overflow-auto" data-id="element-1171">
              {selectedResource.type === 'pdf' && <iframe src={getPreviewUrl(selectedResource.url)} className="w-full h-[70vh]" title={selectedResource.title} data-id="element-1172"></iframe>}
              {selectedResource.type === 'embed-video' && <div className="aspect-w-16 aspect-h-9 h-[70vh]" data-id="element-1173">
                  <iframe src={selectedResource.embedUrl} className="w-full h-full" title={selectedResource.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-1174"></iframe>
                </div>}
              {selectedResource.type === 'video' && <div className="aspect-w-16 aspect-h-9 h-[70vh]" data-id="element-1175">
                  <iframe src={`https://www.youtube.com/embed/${selectedResource.url.split('v=')[1]}`} className="w-full h-full" title={selectedResource.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-1176"></iframe>
                </div>}
            </div>
            <div className="p-4 border-t" data-id="element-1177">
              <a href={selectedResource.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700" data-id="element-1178">
                <Download className="mr-2 h-4 w-4" data-id="element-1179" />
                Download Resource
              </a>
            </div>
          </div>
        </div>}
    </div>;
};
export default Resources;